import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ExecutionAudit, ExecutionAuditFilter, ExecutionQAuditFilter } from 'src/app/model/execution';
import { Subject, merge } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';


import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { ExecutionQService } from 'src/app/services/executionQ.service';
import { ExecutionQAuditDataSource } from 'src/app/model/executionQAuditDataSource';
import { TestTypeEnum } from 'src/app/model/testQType';

@Component({
    selector: 'app-execution-edit-q-audit',
    templateUrl: './execution-edit-q-audit.component.html',
    standalone: false,
})
export class ExecutionQEditAuditComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() idExecution: number;
  @Input() documentCode: string;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public filter: ExecutionQAuditFilter;
  hasFiltered = false;
  public displayedColumns = ['date', 'username', 'action', 'status', 'currentVersion','test','changes', 'download'];
  public dataSource: ExecutionQAuditDataSource;

  private destroy$ = new Subject<void>();

  constructor(
    private executionService: ExecutionQService,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) {
    
  }

  ngOnInit(): void {
    this.filter = new ExecutionQAuditFilter();
    this.getAudit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    
    // reset the paginator after sorting
    this.sort.sortChange.pipe(takeUntil(this.destroy$)).subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page).pipe(tap(() => this.getAudit())).pipe(takeUntil(this.destroy$)).subscribe();
  }

  getAudit(): void {
   
    this.dataSource = new ExecutionQAuditDataSource(this.executionService);

    this.filter.sortBy = this.sort.active || 'date';
    this.filter.sortDirection = this.sort.direction || 'asc';
    this.filter.pageIndex = this.paginator.pageIndex || 0;
    this.filter.pageSize = this.paginator.pageSize || 10;

    if (this.hasFiltered) {
      this.saveSearchFilter(this.filter);
      this.dataSource.loadExecutionAudit(this.idExecution,this.filter);
    }
  

    this.dataSource.loadExecutionAudit(this.idExecution, this.filter);
    this.dataSource.loading$.pipe(takeUntil(this.destroy$)).subscribe(message => this.spinnerService.next(message));
   
  }

  saveSearchFilter(execution: ExecutionQAuditFilter): void {
      localStorage.setItem('filter', JSON.stringify(execution));
  }

  doFilter(event: ExecutionQAuditFilter): void {
      this.filter = event;
      this.hasFiltered = true;
      this.getAudit();
    }
    

  showDownloadSignedPdf(prot: ExecutionAudit): boolean {
    return prot.canDownload;
  }

  private getNameForExecution(documentCode: string, version: string): string {
    let name = documentCode + ' v.' + version.toString().padStart(2, '0');
    name = this.translate.instant('executionEdit.files.report', { name }) as string;

    return name;
  }

  
}
